import { Injectable, signal } from '@angular/core';
import { EmailOcrPngFile } from './email-ocr.service';

@Injectable({
  providedIn: 'root',
})
export class EmailPreviewService {
  // TODO: Make a generic service for previewing PNG files across different modules

  // Signals for PNG preview state
  private _showPngPreview = signal(false);
  private _selectedPngFiles = signal<EmailOcrPngFile[]>([]);

  private _showPngPreviewNewApp = signal(false);
  private _selectedPngFilesNewApp = signal<EmailOcrPngFile[]>([]);

  // Public readonly signals
  readonly showPngPreview = this._showPngPreview.asReadonly();
  readonly selectedPngFiles = this._selectedPngFiles.asReadonly();

  readonly showPngPreviewNewApp = this._showPngPreviewNewApp.asReadonly();
  readonly selectedPngFilesNewApp = this._selectedPngFilesNewApp.asReadonly();

  /**
   * Open PNG preview with files
   */
  openPngPreview(pngFiles: EmailOcrPngFile[]): void {
    this._selectedPngFiles.set(pngFiles);
    this._showPngPreview.set(true);
  }

  openPngPreviewNewApp(pngFiles: EmailOcrPngFile[]): void {
    this._selectedPngFilesNewApp.set(pngFiles);
    this._showPngPreviewNewApp.set(true);
  }

  /**
   * Close PNG preview
   */
  closePngPreview(): void {
    this._showPngPreview.set(false);
    this._selectedPngFiles.set([]);
  }

  closePngPreviewNewApp(): void {
    this._showPngPreviewNewApp.set(false);
    this._selectedPngFilesNewApp.set([]);
  }

  /**
   * Toggle PNG preview visibility
   */
  togglePngPreview(): void {
    if (this._showPngPreview()) {
      this.closePngPreview();
    } else if (this._selectedPngFiles().length > 0) {
      this._showPngPreview.set(true);
    }
  }

  /**
   * Update PNG files without changing visibility
   */
  updatePngFiles(pngFiles: EmailOcrPngFile[]): void {
    this._selectedPngFiles.set(pngFiles);
    if (pngFiles.length === 0) {
      this._showPngPreview.set(false);
    }
  }
}
